<template>
  <div class="new-info widget">
    <div class="go-back-wrapper">
      <span @click="$router.go(-1)">< 返回</span>
    </div>
    <div class="container" v-if="info1">
      <div class="n-top flex">
        <div class="n-left">
          <div class="img-wrapper">
            <img src="@/assets/images/logo.png" />
          </div>
        </div>
        <div class="n-right detail-top">
          <h1>中文名：{{info1.chinese_name}}</h1>
          <p>有害生物学名：<strong> {{info1.name}}</strong></p>
          <p>
            完整学名： <strong>{{info1.full_name}}</strong>
          </p>
          <p>英文名： <strong> {{info1.englist_name}} </strong></p>
          <p>类别： <strong> {{info1.category}}</strong></p>
          <div class="d-operator">
            <span @click="toggleAll">
              <template v-if="isAllShow">[显示基本信息]</template>
              <template v-else>[显示全部信息]</template>
            </span> <span @click="print">[打印]</span>
          </div>
        </div>
      </div>
      <div class="n-btm flex btm-contanier">
        <div class="n-left btm-left">
          <div class="btm-left-container wrap" ref="muneWrap">
            <ul>
              <li
                v-for="(item,index) in info"
                :key="index"
                :class="{active: currentIndex === index}"
                @click="selectLeft(index)"
              >
                <span>{{ item.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="n-right">
          <div ref="containWrap" class="n-right-contain">
            <ul v-if="info">
              <li
                v-for="(item,index) in info"
                :key="index"
                ref="rItem"
                class="right-detail-con"
                :class="'item-classfiy' + index "
                @click="toggleShow(item)"
              >
                <div class="item-top left-line">
                  {{ item.name
                  }}<span
                    :class='{"show-detail":item.show,"hide-detail":!item.show}'
                  ></span>
                </div>
                <div
                  v-if="item.show"
                  class="item-container"
                >
                <span v-if="item.detail=='null' || item.detail=='undefined'" class="no-data">暂无数据</span>
                <div v-else v-html="item.detail">{{ item.detail }}</div>
                  
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import './new-info.scss'
  import Bscroll from 'better-scroll'
 
  export default {
    name: 'NewInfo',
    data() {
      return {
        scrollY: 0, //获取实时滚动位置
        heightList: [], //获取每一个li的高度
        info:null,
        info1:null,
        id:null,
        isAllShow:false
      }
    },
    components: {},
    computed: {
      currentIndex() {
        const index = this.heightList.findIndex((item, index) => {
          return (
            this.scrollY >= this.heightList[index] &&
            this.scrollY < this.heightList[index + 1]
          )
        })
 
        return index > 0 ? index : 0
      }
    },
    methods: {
      _scrollInit() {
        this.muneWrap = new Bscroll(this.$refs.muneWrap, {
          click: true,
          mouseWheel: {
            speed: 20,
            invert: false,
            easeTime: 300
          }
        })
 
        this.containWrap = new Bscroll(this.$refs.containWrap, {
          probeType: 3,
          mouseWheel: {
            speed: 20,
            invert: false,
            easeTime: 300
          }
        })
        this.containWrap.on('scroll', pos => {
          //获取实时滚动的距离 使用scrollY接收
          this.scrollY = Math.abs(Math.round(pos.y + 20))
        })
      },
 
      getHeight() {
        //获取每一个li的高度
        const lis = this.$refs.rItem
        //heightList的第一个元素为0
        let height = 0
        this.heightList.splice(0)
        this.heightList.push(height)
        //之后的高度即为当前li的高度加上之前面li的高度和
        this.$nextTick(() => {
          lis.forEach(item => {
            height += item.clientHeight
            this.heightList.push(height)
          })
        })
      },
      selectLeft(index) {
        let rItem = this.$refs.rItem
        let el = rItem[index]
        this.containWrap.scrollToElement(el, 1000)
      },
 
      toggleShow(item) {
        item.show = !item.show
        this.$forceUpdate()
        this.getHeight()
        this.containWrap.refresh()
        this.muneWrap.refresh()
      },
      toggleAll(){
        const isAllShow = this.isAllShow;
        var info = this.info;
        info.forEach(element => {
          element.show = !isAllShow;
        });
        this.info = info;
        this.$nextTick(() => {
          this.$forceUpdate()
          this.getHeight()
          this.containWrap.refresh()
          this.muneWrap.refresh()
        })
      },
      async getData(id){
          let res = await this.$axios.get('/detail',{params:{id:id}});
          console.log(res.data.data);
          if (res) {
              this.info1 = res.data.data;
          }
          
          
      },
      print(){
        window.print();
      }
    },
 
    mounted() {
      
    },
    async created() {
        var id = this.$route.query.id;        
       await  this.getData(id);
       var info = this.info1;
      this.info = [
        {
          name: '基本信息',
          count: 12,
          show: true,
          detail: `<table style="font-size: 12px; line-height: 22px; color: #333333; text-decoration: none; text-align: left; padding-left: 15px; width: 100%">
                              <tbody><tr>
                                  <td><strong>分类地位：</strong>
                                  </td>
                              </tr>
                              <tr>
                                  <td>目：<span><span>${info.mu}</span></span>
                                  </td>
                              </tr>
                              <tr>
                                  <td>科：<span><span>${info.ke}</span></span>
                                  </td>
                              </tr>
                              <tr>
                                  <td>属：<span><span>${info.shu}</span></span>
                                  </td>
                              </tr>
                              <tr>
                                  <td><strong>拉丁异名：</strong>
                                      <span>${info.other_name}</span>
                                  </td>
                              </tr>
                          </tbody></table>`
        },
        {
          name: '寄主范围',
          count: 22,
          show: false,
          detail: `${info.t1}`
        },
        {
          name: '地理分布',
          count: 12,
          show: false,
          detail: `${info.t2}`
        },
        {
          name: '为害部位',
          count: '2',
          show: false,
          detail: `${info.t3}`
        },
        {
          name: '为害特性',
          count: '2',
          show: false,
          detail: `${info.t4}`
        },
        {
          name: '发生规律',
          count: '2',
          show: false,
          detail: `${info.t5}`
        },
        {
          name: '生态要求',
          count: '2',
          show: false,
          detail: `${info.t6}`
        },
        { name: '防治方法', count: 2, show: false, detail: `${info.t7}` },
        {
          name: '其他信息',
          count: 2,
          show: false,
          detail: `${info.t8}`
        },
        { name: '传播媒介', show: false, count: 3, detail: `${info.t9}` },
        {
          name: '各国限定性情况',
          count: 3,
          show: false,
          detail: `${info.t10}`
        },
        {
          name: '其它限定性情况',
          count: 3,
          show: false,
          detail: `${info.t11}`
        },
        {
          name: '鉴定方法',
          count: 3,
          show: false,
          detail: `${info.t12}`
        },
        {
          name: '评估方法',
          show: false,
          count: 3,
          detail: `${info.t13}`
        }
      ]
 
      console.log(this.info);
      
      this.$nextTick(() => {
        this._scrollInit()
        this.getHeight()
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/new-info/new-info.vue